/**
 * Do not edit directly
 * Generated on Tue, 11 Jul 2023 12:04:42 GMT
 */
export var aliasActionBorderRadius = "2px";
export var aliasBackdropColorBase = "#000000";
export var aliasBackdropOpacityBase = 0.73;
export var aliasFocusColor = "#82BCF3";
export var aliasFocusColorError = "#f97a7d";
export var aliasFocusColorSuccess = "rgba(21, 134, 55, 0.5)";
export var aliasFocusWidth = "3px";
export var aliasFocusBoxShadow = "0 0 0 3px #82BCF3";
export var aliasFocusBoxShadowError = "0 0 0 3px #f97a7d";
export var aliasFocusBoxShadowSuccess = "0 0 0 3px rgba(21, 134, 55, 0.5)";
export var aliasFocusRingColorBase = "#F0ACAC";
export var aliasFocusRingColorError = "#f97a7d";
export var aliasFocusRingSizeBase = "3px";
export var aliasInputBorderWidth = "1px";
export var aliasInputBorderRadius = "4px";
export var aliasInputBorderColor = "#999999";
export var aliasInputBorderColorHover = "#023361";
export var aliasInputBorderColorError = "#e92326";
export var aliasInputBorderColorSuccess = "#1ab11d";
export var aliasInputBorderColorActive = "#000000";
export var aliasInputBorderColorFocus = "#999999";
export var aliasInputBorderColorDisabled = "#CCCCCC";
export var aliasInputBorderColorChecked = "#023361";
export var aliasInputBackgroundColor = "#ffffff";
export var aliasInputBackgroundColorError = "#e92326";
export var aliasInputBackgroundColorActive = "#002140";
export var aliasInputBackgroundColorFocus = "#2074C2";
export var aliasInputBackgroundColorDisabled = "#E6E6E6";
export var aliasInputBackgroundColorChecked = "#023361";
export var aliasInputTextColorChecked = "#ffffff";
export var aliasInputBoxShadow = "0 2px 4px 0 rgba(0,0,0,0.12)";
export var aliasInputBoxShadowActive = "inset 0 1px 5px 0 #000000";
export var aliasInputBoxShadowFocus = "0 0 0 3px #82BCF3";
export var aliasInputBoxShadowError = "0 0 0 3px #f97a7d";
export var aliasInputBoxShadowSuccess = "0 0 0 3px rgba(21, 134, 55, 0.5)";
export var aliasFieldBorderWidthBase = "1px";
export var aliasFieldBorderColorBase = "#999999";
export var aliasFieldBorderColorHover = "#023361";
export var aliasFieldBorderColorError = "#e92326";
export var aliasFieldBorderColorActive = "#000000";
export var aliasFieldBorderColorFocus = "#999999";
export var aliasFieldBorderColorDisabled = "#CCCCCC";
export var aliasFieldBorderColorChecked = "#023361";
export var aliasFieldBackgroundColorBase = "#ffffff";
export var aliasFieldBackgroundColorError = "#e92326";
export var aliasFieldBackgroundColorActive = "#002140";
export var aliasFieldBackgroundColorFocus = "#2074C2";
export var aliasFieldBackgroundColorDisabled = "#E6E6E6";
export var aliasFieldBackgroundColorChecked = "#023361";
export var aliasFieldTextChecked = "#ffffff";
export var aliasFieldShadowBase = "0 2px 4px 0 rgba(0,0,0,0.12)";
export var aliasFieldShadowActive = "inset 0 1px 5px 0 #000000";
export var aliasFieldShadowFocus = "0 0 0 3px #82BCF3";
export var aliasFieldShadowError = "0 0 0 3px #f97a7d";
export var colorBlackBase = "#000000";
export var colorText10 = "#000000";
export var colorText20 = "#000000";
export var colorText30 = "#000000";
export var colorText40 = "#000000";
export var colorText50 = "#000000";
export var colorText60 = "#ffffff";
export var colorText70 = "#ffffff";
export var colorText80 = "#ffffff";
export var colorText90 = "#ffffff";
export var colorText100 = "#ffffff";
export var colorTextBlackBase = "#ffffff";
export var colorTextBlue10 = "#000000";
export var colorTextBlue20 = "#000000";
export var colorTextBlue30 = "#000000";
export var colorTextBlue40 = "#000000";
export var colorTextBlue50 = "#000000";
export var colorTextBlue60 = "#ffffff";
export var colorTextBlue70 = "#ffffff";
export var colorTextBlue80 = "#ffffff";
export var colorTextBlue90 = "#ffffff";
export var colorTextBlue100 = "#ffffff";
export var colorTextBlueLight = "#000000";
export var colorTextBlueBase = "#000000";
export var colorTextBlueDark = "#ffffff";
export var colorTextGreen10 = "#000000";
export var colorTextGreen20 = "#000000";
export var colorTextGreen30 = "#000000";
export var colorTextGreen40 = "#000000";
export var colorTextGreen50 = "#000000";
export var colorTextGreen60 = "#ffffff";
export var colorTextGreen70 = "#ffffff";
export var colorTextGreen80 = "#ffffff";
export var colorTextGreen90 = "#ffffff";
export var colorTextGreen100 = "#ffffff";
export var colorTextGreenLight = "#000000";
export var colorTextGreenBase = "#000000";
export var colorTextGreenDark = "#ffffff";
export var colorTextGrey10 = "#000000";
export var colorTextGrey20 = "#000000";
export var colorTextGrey30 = "#000000";
export var colorTextGrey40 = "#000000";
export var colorTextGrey50 = "#000000";
export var colorTextGrey60 = "#000000";
export var colorTextGrey70 = "#ffffff";
export var colorTextGrey80 = "#ffffff";
export var colorTextGrey90 = "#ffffff";
export var colorTextGrey100 = "#ffffff";
export var colorTextGreyLight = "#000000";
export var colorTextGreyBase = "#000000";
export var colorTextGreyDark = "#000000";
export var colorTextMarketing10 = "#000000";
export var colorTextMarketing20 = "#000000";
export var colorTextMarketing30 = "#000000";
export var colorTextMarketing40 = "#000000";
export var colorTextMarketing50 = "#000000";
export var colorTextMarketing60 = "#000000";
export var colorTextMarketing70 = "#000000";
export var colorTextMarketing80 = "#ffffff";
export var colorTextMarketing90 = "#ffffff";
export var colorTextMarketing100 = "#ffffff";
export var colorTextMarketingLight = "#000000";
export var colorTextMarketingBase = "#000000";
export var colorTextMarketingDark = "#000000";
export var colorTextOrange10 = "#000000";
export var colorTextOrange20 = "#000000";
export var colorTextOrange30 = "#000000";
export var colorTextOrange40 = "#000000";
export var colorTextOrange50 = "#000000";
export var colorTextOrange60 = "#ffffff";
export var colorTextOrange70 = "#ffffff";
export var colorTextOrange80 = "#ffffff";
export var colorTextOrange90 = "#ffffff";
export var colorTextOrange100 = "#ffffff";
export var colorTextOrangeLight = "#000000";
export var colorTextOrangeBase = "#000000";
export var colorTextOrangeDark = "#ffffff";
export var colorTextPrimary10 = "#000000";
export var colorTextPrimary20 = "#000000";
export var colorTextPrimary30 = "#000000";
export var colorTextPrimary40 = "#000000";
export var colorTextPrimary50 = "#ffffff";
export var colorTextPrimary60 = "#ffffff";
export var colorTextPrimary70 = "#ffffff";
export var colorTextPrimary80 = "#ffffff";
export var colorTextPrimary90 = "#ffffff";
export var colorTextPrimary100 = "#ffffff";
export var colorTextPrimaryLight = "#000000";
export var colorTextPrimaryBase = "#ffffff";
export var colorTextPrimaryDark = "#ffffff";
export var colorTextRed10 = "#000000";
export var colorTextRed20 = "#000000";
export var colorTextRed30 = "#000000";
export var colorTextRed40 = "#000000";
export var colorTextRed50 = "#000000";
export var colorTextRed60 = "#ffffff";
export var colorTextRed70 = "#ffffff";
export var colorTextRed80 = "#ffffff";
export var colorTextRed90 = "#ffffff";
export var colorTextRed100 = "#ffffff";
export var colorTextRedLight = "#000000";
export var colorTextRedBase = "#000000";
export var colorTextRedDark = "#ffffff";
export var colorTextSecondary10 = "#000000";
export var colorTextSecondary20 = "#000000";
export var colorTextSecondary30 = "#000000";
export var colorTextSecondary40 = "#000000";
export var colorTextSecondary50 = "#000000";
export var colorTextSecondary60 = "#ffffff";
export var colorTextSecondary70 = "#ffffff";
export var colorTextSecondary80 = "#ffffff";
export var colorTextSecondary90 = "#ffffff";
export var colorTextSecondary100 = "#ffffff";
export var colorTextSecondaryLight = "#000000";
export var colorTextSecondaryBase = "#ffffff";
export var colorTextSecondaryDark = "#ffffff";
export var colorTextTertiary10 = "#000000";
export var colorTextTertiary20 = "#000000";
export var colorTextTertiary30 = "#000000";
export var colorTextTertiary40 = "#000000";
export var colorTextTertiary50 = "#000000";
export var colorTextTertiary60 = "#000000";
export var colorTextTertiary70 = "#000000";
export var colorTextTertiary80 = "#ffffff";
export var colorTextTertiary90 = "#ffffff";
export var colorTextTertiary100 = "#ffffff";
export var colorTextTertiaryLight = "#000000";
export var colorTextTertiaryBase = "#000000";
export var colorTextTertiaryDark = "#000000";
export var colorTextWhiteBase = "#000000";
export var colorBlue10 = "#e0f3ff";
export var colorBlue20 = "#ade2fe";
export var colorBlue30 = "#68c3f5";
export var colorBlue40 = "#2da2e3";
export var colorBlue50 = "#0280c6";
export var colorBlue60 = "#00649c";
export var colorBlue70 = "#004c75";
export var colorBlue80 = "#003958";
export var colorBlue90 = "#002d46";
export var colorBlue100 = "#00283d";
export var colorBlueLight = "#2da2e3";
export var colorBlueBase = "#0280c6";
export var colorBlueDark = "#00649c";
export var colorGreen10 = "#e0ffe0";
export var colorGreen20 = "#b2f9b4";
export var colorGreen30 = "#74eb76";
export var colorGreen40 = "#40d342";
export var colorGreen50 = "#1ab11d";
export var colorGreen60 = "#048907";
export var colorGreen70 = "#006402";
export var colorGreen80 = "#005a02";
export var colorGreen90 = "#003b01";
export var colorGreen100 = "#003601";
export var colorGreenLight = "#40d342";
export var colorGreenBase = "#1ab11d";
export var colorGreenDark = "#048907";
export var colorGrey10 = "#F2F2F2";
export var colorGrey20 = "#E6E6E6";
export var colorGrey30 = "#CCCCCC";
export var colorGrey40 = "#B3B3B3";
export var colorGrey50 = "#999999";
export var colorGrey60 = "#808080";
export var colorGrey70 = "#666666";
export var colorGrey80 = "#4D4D4D";
export var colorGrey90 = "#333333";
export var colorGrey100 = "#1A1A1A";
export var colorGreyLight = "#B3B3B3";
export var colorGreyBase = "#999999";
export var colorGreyDark = "#808080";
export var colorMarketing10 = "#FFFBE6";
export var colorMarketing20 = "#F9EEB2";
export var colorMarketing30 = "#F0DF80";
export var colorMarketing40 = "#E1CC55";
export var colorMarketing50 = "#CCB534";
export var colorMarketing60 = "#B09A1D";
export var colorMarketing70 = "#8A770D";
export var colorMarketing80 = "#5E5104";
export var colorMarketing90 = "#302901";
export var colorMarketing100 = "#050400";
export var colorMarketingLight = "#E1CC55";
export var colorMarketingBase = "#CCB534";
export var colorMarketingDark = "#B09A1D";
export var colorOrange10 = "#fff4e6";
export var colorOrange20 = "#ffe9c7";
export var colorOrange30 = "#ffdea8";
export var colorOrange40 = "#ffc066";
export var colorOrange50 = "#ffa024";
export var colorOrange60 = "#e98400";
export var colorOrange70 = "#cc7300";
export var colorOrange80 = "#a75e00";
export var colorOrange90 = "#7b4600";
export var colorOrange100 = "#4d2b00";
export var colorOrangeLight = "#ffc066";
export var colorOrangeBase = "#ffa024";
export var colorOrangeDark = "#e98400";
export var colorPrimary10 = "#FFE6E6";
export var colorPrimary20 = "#F8C8C8";
export var colorPrimary30 = "#F0ACAC";
export var colorPrimary40 = "#E37373";
export var colorPrimary50 = "#D23E3E";
export var colorPrimary60 = "#C51111";
export var colorPrimary70 = "#B10B0B";
export var colorPrimary80 = "#950606";
export var colorPrimary90 = "#720202";
export var colorPrimary100 = "#4D0000";
export var colorPrimaryLight = "#E37373";
export var colorPrimaryBase = "#D23E3E";
export var colorPrimaryDark = "#C51111";
export var colorRed10 = "#ffebeb";
export var colorRed20 = "#fdb5b6";
export var colorRed30 = "#f97a7d";
export var colorRed40 = "#f2494c";
export var colorRed50 = "#e92326";
export var colorRed60 = "#dd070b";
export var colorRed70 = "#cd0003";
export var colorRed80 = "#b80003";
export var colorRed90 = "#a00003";
export var colorRed100 = "#870002";
export var colorRedLight = "#f97a7d";
export var colorRedBase = "#e92326";
export var colorRedDark = "#cd0003";
export var colorSecondary10 = "#E6F3FF";
export var colorSecondary20 = "#B3D8FB";
export var colorSecondary30 = "#82BCF3";
export var colorSecondary40 = "#58A2E8";
export var colorSecondary50 = "#378AD8";
export var colorSecondary60 = "#2074C2";
export var colorSecondary70 = "#105DA6";
export var colorSecondary80 = "#064784";
export var colorSecondary90 = "#023361";
export var colorSecondary100 = "#002140";
export var colorSecondaryLight = "#378AD8";
export var colorSecondaryBase = "#2074C2";
export var colorSecondaryDark = "#105DA6";
export var colorTertiary10 = "#E6FFF5";
export var colorTertiary20 = "#B3FBDF";
export var colorTertiary30 = "#82F3C8";
export var colorTertiary40 = "#58E8B1";
export var colorTertiary50 = "#37D89B";
export var colorTertiary60 = "#20C284";
export var colorTertiary70 = "#10A66C";
export var colorTertiary80 = "#068454";
export var colorTertiary90 = "#02613C";
export var colorTertiary100 = "#004027";
export var colorTertiaryLight = "#58E8B1";
export var colorTertiaryBase = "#37D89B";
export var colorTertiaryDark = "#20C284";
export var colorWhiteBase = "#ffffff";
export var accordionItemHoverTitleColor = "#D23E3E";
export var autocompleteLoadingOverlayBackground = "rgba(255, 255, 255, 0.73)";
export var avatarSquareBorderRadius = "4px";
export var backdropBackground = "rgba(0, 0, 0, 0.73)";
export var bannerRootBorderRadius = "4px";
export var calendarRootDayPickerNavButtonBorderRadius = "4px";
export var calendarRootDayPickerDayBorderRadius = "4px";
export var checkboxIconContainerBorderRadius = "2px";
export var checkboxCheckedColor = "#ffffff";
export var checkboxCheckedBackground = "#023361";
export var choiceContentBorderRadius = "4px";
export var choiceBodyBorderRadius = "2px";
export var choiceInfoColor = "#4D4D4D";
export var choiceTitleColor = "#4D4D4D";
export var choiceMessageColor = "#808080";
export var choiceCheckedInfoColor = "#002140";
export var choiceCheckedTitleColor = "#002140";
export var choiceCheckedBackground = "#E6F3FF";
export var choiceCheckedBorderColor = "#023361";
export var choiceCheckedIconColor = "#002140";
export var choiceCheckedIconBackground = "#023361";
export var dateTimeFormatDate = "DD/MM/YYYY";
export var dateTimeFormatTime = "HH:mm";
export var dateTimeFormatDateTime = "ddd DD MMM YYYY [at] HH:mm";
export var dateTimeFormatDefault = "DD/MM/YYYY [at] HH:mm";
export var dialogRootBorderRadius = "4px";
export var imageWrapperBorderRadius = "0px";
export var inputFontSize = "16px";
export var labelOptionalFontSize = "16px";
export var labelActionFontSize = "14px";
export var labelActionLineHeight = "20px";
export var linkTextDefaultColor = "#0280c6";
export var linkTextDefaultHoverColor = "#0280c6";
export var linkTextDefaultVisitedColor = "#2da2e3";
export var linkTextDefaultActiveColor = "#00649c";
export var linkTextBrandedColor = "#D23E3E";
export var linkTextBrandedHoverColor = "#D23E3E";
export var linkTextBrandedVisitedColor = "#E37373";
export var linkTextBrandedActiveColor = "#C51111";
export var loaderColorBase = "#D23E3E";
export var loaderColorLight = "#F8C8C8";
export var loaderXxLarge = "40px";
export var loaderXLarge = "32px";
export var loaderLarge = "28px"; // Mainly for ios

export var loaderMedium = "24px";
export var loaderSmall = "16px";
export var paperWrapperBorderRadius = "2px";
export var placeholderRootBorderRadius = "0px";
export var radioCheckedColor = "#023361";
export var stepCompletedNumberColor = "#ffffff";
export var stepCompletedNumberBackground = "#D23E3E";
export var stepCompletedLineColor = "#D23E3E";
export var stepCompletedLabelColor = "#D23E3E";
export var stepLabelFontSize = "14px";
export var stepNumberFontSize = "16px";
export var switchCheckedColor = "#ffffff";
export var switchCheckedBackground = "#023361";
export var switchActiveBackground = "#002140";
export var tableRootBorderRadius = "4px";
export var tooltipContainerBorderRadius = "4px";
export var widelistRootBorderRadius = "4px";
export var shadow0 = "none";
export var shadow1 = "0 2px 4px 0 rgba(0,0,0,0.12)";
export var shadow2 = "0 2px 7px 0 rgba(0,0,0,0.28)";
export var shadow3 = "0 7px 14px 0 rgba(0,0,0,0.28)";
export var shadow4 = "0 14px 28px 0 rgba(0,0,0,0.28)";
export var shadowInset1 = "inset 0 1px 10px 0 rgba(0,0,0,0.24)";
export var shadowInset2 = "inset 0 1px 15px 0 rgba(0,0,0,0.28)";
export var zIndex100 = 100; // tooltip

export var zIndex200 = 200; // menu

export var zIndex300 = 300; // popover

export var zIndex400 = 400; // sticky content

export var zIndex500 = 500; // sheet

export var zIndex600 = 600; // modal backdrop

export var zIndex700 = 700; // modal sheet

export var zIndex800 = 800; // modal (dialog, alert, page, full screen)

export var zIndex900 = 900; // toast

export var motionDurationFast = "200ms";
export var motionDurationMedium = "300ms";
export var motionDurationSlow = "500ms";
export var motionDurationLoop = "1200ms";
export var gridBreakpointXSmall = 0; // Mobile (portrait) | Grid Fluid

export var gridBreakpointXSmallMax = "374px"; // Mobile (portrait) | Grid Fluid

export var gridBreakpointSmall = "375px"; // Mobile (landscape) | Grid Fluid

export var gridBreakpointSmallMax = "767px"; // Mobile (landscape) | Grid Fluid

export var gridBreakpointMedium = "768px"; // Tablet (portrait) | Grid Fluid

export var gridBreakpointMediumMax = "1023px"; // Tablet (portrait) | Grid Fluid

export var gridBreakpointLarge = "1024px"; // Desktop (13inch) / Tablet (landscape) | Grid Fluid

export var gridBreakpointLargeMax = "1319px"; // Desktop (13inch) / Tablet (landscape) | Grid Fluid

export var gridBreakpointXLarge = "1320px"; // HD Desktop (15inch and up) | Grid Static: 1200

export var gridGutter = "16px";
export var gridWrapFluid = "calc(100% - 32px)"; // Mobile Grid Fluid

export var gridWrapStatic = "1200px"; // Desktop static

export var space1 = "2px";
export var space2 = "4px";
export var space3 = "8px";
export var space4 = "12px";
export var space5 = "16px";
export var space6 = "24px";
export var space7 = "32px";
export var space8 = "40px";
export var space9 = "48px";
export var space10 = "64px";
export var space11 = "96px";
export var borderRadius0 = "0px";
export var borderRadius1 = "2px";
export var borderRadius2 = "4px";
export var borderRadius3 = "8px";
export var borderRadius4 = "12px";
export var borderRadius5 = "16px";
export var borderRadius6 = "24px";
export var borderRadius7 = "32px";
export var borderRadius8 = "40px";
export var borderRadius9 = "48px";
export var borderRadius10 = "64px";
export var borderRadius11 = "96px";
export var borderRadiusSides = "9999px";
export var borderRadiusFill = "50%";
export var overlayFill = "rgba(0, 0, 0, 0.33)";
export var overlayGradientLinearFadeToTop = "linear-gradient(-180deg, rgba(213, 219, 224, 0) 0%, rgba(0, 0, 0, 0.33) 100%)";
export var overlayGradientLinearFadeToBottom = "linear-gradient(-180deg, rgba(0, 0, 0, 0.33) 0%, rgba(255, 255, 255, 0) 100%)";
export var fontCaption1Size = "14px";
export var fontCaption1LineHeight = "1.1429";
export var fontCaption2Size = "12px";
export var fontCaption2LineHeight = "1.3333";
export var fontHeading1Size = "32px"; // h1

export var fontHeading1LineHeight = "1.375"; // h1

export var fontHeading1Weight = "700"; // h1

export var fontHeading1LargeSize = "40px"; // h1

export var fontHeading1LargeLineHeight = "1.3"; // h1

export var fontHeading2Size = "28px"; // h2

export var fontHeading2LineHeight = "1.2857"; // h2

export var fontHeading2Weight = "700"; // h2

export var fontHeading2LargeSize = "32px"; // h2

export var fontHeading2LargeLineHeight = "1.25"; // h2

export var fontHeading3Size = "24px"; // h3

export var fontHeading3LineHeight = "1.3333"; // h3

export var fontHeading3Weight = "700"; // h3

export var fontHeading3LargeSize = "28px"; // h3

export var fontHeading3LargeLineHeight = "1.2857"; // h3

export var fontHeading4Size = "22px"; // h4

export var fontHeading4LineHeight = "1.2727"; // h4

export var fontHeading4Weight = "700"; // h4

export var fontHeading4LargeSize = "22px"; // h4

export var fontHeading4LargeLineHeight = "1.2727"; // h4

export var fontHeading5Size = "18px"; // h5

export var fontHeading5LineHeight = "1.3333"; // h5

export var fontHeading5Weight = "700"; // h5

export var fontHeading5LargeSize = "18px"; // h5

export var fontHeading5LargeLineHeight = "1.3333"; // h5

export var fontHeading6Size = "16px"; // h6

export var fontHeading6LineHeight = "1.25"; // h6

export var fontHeading6Weight = "700"; // h6

export var fontHeading6LargeSize = "16px"; // h6

export var fontHeading6LargeLineHeight = "1.25"; // h6

export var fontParagraphSize = "16px";
export var fontParagraphLineHeight = "1.5";
export var fontParagraphLargeSize = "18px";
export var fontParagraphLargeLineHeight = "1.5556";
export var fontFamilyBrandPrimary = "'Roboto Slab', 'Roboto Slab Fallback', serif"; // UI Display (e.g. section title)

export var fontFamilyBrandSecondary = "'Roboto', 'Roboto Fallback', sans-serif"; // Article Display (e.g. teaser title)

export var fontFamilySystem = "-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"; // UI Text (e.g. link text) -> body 1

export var fontSize6XLarge = "40px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize5XLarge = "32px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize4XLarge = "28px"; // use font.heading, font.paragraph, font.caption instead

export var fontSize3XLarge = "24px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXxLarge = "22px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXLarge = "20px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeLarge = "18px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeMedium = "16px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeSmall = "14px"; // use font.heading, font.paragraph, font.caption instead

export var fontSizeXSmall = "12px"; // use font.heading, font.paragraph, font.caption instead

export var fontWeightRegular = "400"; // normal

export var fontWeightMedium = "500"; // medium

export var fontWeightBold = "700"; // bold

export var lineHeight4XLarge = "48px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeight3XLarge = "44px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXxLarge = "40px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXLarge = "32px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightLarge = "28px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightMedium = "24px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightSmall = "20px"; // use font.heading, font.paragraph, font.caption instead

export var lineHeightXSmall = "16px"; // use font.heading, font.paragraph, font.caption instead

export var buttonDefaultHoverBackground = "rgba(0, 0, 0, 0.05)";
export var buttonDefaultActiveBackground = "rgba(0, 0, 0, 0.1)";
export var buttonOutlineBackground = "rgba(0, 0, 0, 0)";
export var buttonOutlineBorderColor = "#000000";
export var buttonOutlineBorderWidth = "1px";
export var buttonOutlineColor = "#000000";
export var buttonOutlineHoverBorderColor = "#D23E3E";
export var buttonOutlineHoverColor = "#D23E3E";
export var buttonOutlineFocusBorderColor = "#D23E3E";
export var buttonOutlineFocusColor = "#D23E3E";
export var buttonOutlineHoverBackground = "rgba(0, 0, 0, 0)";
export var buttonOutlineFocusBackground = "rgba(0, 0, 0, 0)";
export var buttonOutlineActiveBackground = "#FFE6E6";
export var buttonOutlineActiveColor = "#D23E3E";
export var buttonOutlineActiveBorderColor = "#D23E3E";
export var buttonOutlineShadow = "none";
export var buttonOutlineHoverShadow = "none";
export var buttonOutlineActiveShadow = "none";
export var buttonPlainBackground = "#ffffff";
export var buttonPlainColor = "#D23E3E";
export var buttonPlainHoverBackground = "#FFE6E6";
export var buttonPlainHoverColor = "#D23E3E";
export var buttonPlainHoverTextDecoration = "none";
export var buttonPlainActiveBackground = "#F8C8C8";
export var buttonPlainActiveColor = "#D23E3E";
export var buttonPlainFocusColor = "#D23E3E";
export var buttonPlainShadow = "none";
export var buttonPlainHoverShadow = "none";
export var buttonPlainActiveShadow = "none";
export var buttonPrimaryBackground = "#D23E3E";
export var buttonPrimaryColor = "#ffffff";
export var buttonPrimaryBorderColor = "#D23E3E";
export var buttonPrimaryBorderWidth = "0px";
export var buttonPrimaryHoverBackground = "#C51111";
export var buttonPrimaryHoverColor = "#ffffff";
export var buttonPrimaryActiveBackground = "#B10B0B";
export var buttonPrimaryActiveColor = "#ffffff";
export var buttonPrimaryFocusBackground = "#D23E3E";
export var buttonPrimaryFocusColor = "#ffffff";
export var buttonPrimaryShadow = "none";
export var buttonPrimaryHoverShadow = "none";
export var buttonPrimaryActiveShadow = "none";
export var buttonFontFamily = "'Roboto', 'Roboto Fallback', sans-serif";
export var buttonFontWeight = "500";
export var buttonFocusShadow = "0 0 0 3px #82BCF3";
export var buttonSmallFontSize = "14px";
export var buttonLargeFontSize = "16px";
export var buttonSmallHeight = "32px";
export var buttonLargeHeight = "48px";
export var buttonSmallPaddingHorizontal = "16px";
export var buttonLargePaddingHorizontal = "24px";
export var buttonIconPadding = "2px";
export var buttonSecondaryBackground = "#F2F2F2";
export var buttonSecondaryColor = "#D23E3E";
export var buttonSecondaryBorderWidth = "0px";
export var buttonSecondaryBorderColor = "#F2F2F2";
export var buttonSecondaryHoverBackground = "#E6E6E6";
export var buttonSecondaryHoverColor = "#D23E3E";
export var buttonSecondaryActiveBackground = "#CCCCCC";
export var buttonSecondaryActiveColor = "#D23E3E";
export var buttonSecondaryFocusColor = "#D23E3E";
export var buttonSecondaryFocusBackground = "#F2F2F2";
export var buttonSecondaryShadow = "none";
export var buttonSecondaryHoverShadow = "none";
export var buttonSecondaryActiveShadow = "none";
export var iconXLarge = "32px";
export var iconLarge = "28px"; // Mainly for ios

export var iconMedium = "24px";
export var iconSmall = "16px";